import { useState, useMemo } from 'react'

import {
	EuiButtonEmpty,
	EuiFieldSearch,
	EuiFilterButton,
	EuiFilterGroup,
	EuiLoadingSpinner,
	EuiPopover,
	EuiPopoverTitle,
	EuiSpacer,
} from '@equipmentshare/ds2'

import {
	ArrowUpSLineIcon,
	ArrowDownSLineIcon,
} from '@equipmentshare/ds2-icons'

import InventoryLocationsSelectable from '../InventoryLocationsSelectable'
import InventoryLocationsFooter from './components/InventoryLocationsFooter'

import useInputDebounce from 'hooks/useInputDebounce'
import useInventoryLocationsSearch, { groupInventoryLocationsByBranch } from 'hooks/inventory-location-search'
import useStoreIds from 'hooks/useStoreIds'

const DEBOUNCE_DELAY_MS = 300

export default function InventoryLocationsFilter() {
	const [ inputVal, setInputVal ] = useState( '' )
	const [ search, setSearch ] = useState( '' )
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )
	const { inventoryLocationIds, setInventoryLocationIds } = useStoreIds()


	const { loading, filteredInventoryLocations } = useInventoryLocationsSearch( search, 'inventory-locations-filter', 'no-cache', undefined, undefined, true )

	useInputDebounce( inputVal, DEBOUNCE_DELAY_MS, ( debouncedInputVal ) => setSearch( debouncedInputVal ) )
	const onInputChange = ( event: React.ChangeEvent<HTMLInputElement> ) => setInputVal( event.currentTarget.value )

	const onClickDeselectAll = () => setInventoryLocationIds( [] )

	const branches = useMemo( () => groupInventoryLocationsByBranch( filteredInventoryLocations ), [ filteredInventoryLocations ] )

	const togglePopover = () => setIsPopoverOpen( !isPopoverOpen )
	const closePopover = () => setIsPopoverOpen( false )

	const button = (
		<EuiFilterButton
			iconType={isPopoverOpen ? ArrowUpSLineIcon : ArrowDownSLineIcon}
			iconSide="right"
			isSelected={isPopoverOpen}
			onClick={togglePopover}
		>
			Stores
		</EuiFilterButton>
	)

	return (
		<EuiFilterGroup>
			<EuiPopover
				button={button}
				isOpen={isPopoverOpen}
				closePopover={closePopover}
				panelPaddingSize="none"
				style={{ maxHeight: '500px' }}
			>
				<EuiPopoverTitle
					style={{ textAlign: 'center', border: 'none' }}
					paddingSize="s"
				>
					<EuiFieldSearch
						compressed
						value={inputVal}
						onChange={onInputChange}
					/>
					<EuiButtonEmpty
						onClick={onClickDeselectAll}
						id="deselectAllBtn"
					>
						Deselect all
					</EuiButtonEmpty>
				</EuiPopoverTitle>
				<div
					className="euiFilterSelect__items"
					style={{ width: '400px', height: '500px' }}
				>
				 	<InventoryLocationsSelectable
						branches={branches}
						selectedIds={inventoryLocationIds}
						setSelectedIds={setInventoryLocationIds}
		 			/>
				</div>
				{ loading && (
					<div className="euiFilterSelect__note">
						<div className="euiFilterSelect__noteContent">
							<EuiLoadingSpinner size="m" />
							<EuiSpacer size="xs" />
							<p>Loading...</p>
						</div>
					</div>
				) }
				<InventoryLocationsFooter closePopover={closePopover} />
			</EuiPopover>
		</EuiFilterGroup>
	)
}
